import { WithId } from '@WombatTechnology/nitte-time-lib'
import {
  CollectionReference,
  DocumentData,
  DocumentReference,
  getDoc,
  getDocs,
  QuerySnapshot
} from 'firebase/firestore'

/**
 * DocumentReferenceをデータに変換する
 * @param doc
 * @returns
 */
export const toData = async <M>(
  doc: DocumentReference<M, DocumentData>
): Promise<M> => {
  const ds = await getDoc<M, DocumentData>(doc)
  return ds.data() as M
}

export const toDataWithId = async <M>(
  doc: DocumentReference<M, DocumentData>
): Promise<WithId<M>> => {
  const ds = await getDoc<M, DocumentData>(doc)
  return { id: doc.id, ...(ds.data() as M) }
}

/**
 * CollectionReferenceをデータの配列に変換する
 * @param collection
 * @returns
 */
export const toCollectionData = async <M>(
  collection: CollectionReference<M>
): Promise<M[]> => {
  const qs = await getDocs(collection)
  return qsToData(qs)
}
/**
 * クエリのスナップショットをデータの配列に変換する
 */
const qsToData = <M>(qs: QuerySnapshot<M>) => {
  return qs.docs.map((d) => d.data() as M)
}
